<!-- This component will be loaded in layout.blade.php every login page for Admin at the moment -->
<!-- within template, you can access props like how we access data  -->
<template>
	<li class="dropdown messages-menu">
	  <a href="#" class="dropdown-toggle" data-toggle="dropdown">
	    <i class="fa fa-envelope-o"></i>
	    <!-- <span class="label label-success" id="new_msg_count" v-if="newMsgs_count > 0">{{ newMsgs_count }}</span> -->
	    <span class="label label-success" id="new_msg_count">{{ newMsgs_count }}</span>
	  </a>
	  <ul class="dropdown-menu">
	    <li class="header">You have <span id="new_msg_count2">{{ newMsgs_count }}</span> message<span id="new_msg_count_s">{{ (newMsgs_count > 0) ? 's' : '' }}</span></li>
	    <li>
	      <!-- inner menu: contains the actual data -->
	      <ul class="menu">
	      	<li v-for="newmsg in newMsgs_list"><!-- start message -->
	      		<a :href="baseroute + '/inbox/' + newmsg.hashed_id">
	      		  <div class="pull-left">
	      		    <img :src="whatsapp_icon_src" class="img-circle" alt="User Image">
	      		  </div>
	      		  <h4>
	      		    {{ newmsg.receiver }}
	      		    <span style="font-size:10px;" v-if="newmsg.company_id != company_id">({{ newmsg.company_shortname }})</span>
	      		    <small>
	      		    	<i class="fa fa-clock-o"></i>
	      		    	    <template v-if="currentDateTime.diff(newmsg.updated_at, 'minutes') < 60">{{ (currentDateTime.diff(newmsg.updated_at, 'minutes')) }} min{{ (currentDateTime.diff(newmsg.updated_at, 'minutes') > 1) ? 's' : '' }}</template>
	      		    	    <template v-else-if="(currentDateTime.diff(newmsg.updated_at, 'hours') < 10)">{{ (currentDateTime.diff(newmsg.updated_at, 'hours')) }} hour{{ (currentDateTime.diff(newmsg.updated_at, 'hours') > 1) ? 's' : '' }}</template>
	      		    	    <template v-else-if="(currentDateTime.diff(newmsg.updated_at, 'hours') <= 24)">Today</template>
	      		    	    <template v-else-if="(currentDateTime.diff(newmsg.updated_at, 'hours') > 24) && (currentDateTime.diff(newmsg.updated_at, 'hours') < 48)">Yesterday</template>
	      		    	    <template v-else-if="(currentDateTime.diff(newmsg.updated_at, 'hours') >= 48) && (currentDateTime.diff(newmsg.updated_at, 'days') < 8)">{{ currentDateTime.diff(newmsg.updated_at, 'days') }} day{{ (currentDateTime.diff(newmsg.updated_at, 'days') > 1) ? 's' : '' }}</template>
	      		    	    <template v-else-if="(currentDateTime.diff(newmsg.updated_at, 'days') >= 8)">{{ moment(newmsg.updated_at).format('Do MMM') }}</template>	      		    	    
	      		    </small>
	      		    <br />
	      		    <template v-if="newmsg.unread > 0">
	      		        <span class="label label-success pull-right" v-if="newmsg.type == 10">{{ newmsg.unread }}</span>
	      		        <span class="label label-warning pull-right" v-else>{{ newmsg.unread }}</span>
	      		    </template>
	      		  </h4>
	      		  <p>{{ newmsg.content }}</p>
	      		</a>
	      	</li><!-- end message -->
	        
	        
	      </ul>
	    </li>
	    <li class="footer"><a :href="inbox_url">See All Messages</a></li>
	  </ul>
	</li>
</template>


<script>
	import moment from 'moment'
    var axios = require('axios');

    export default {
		data() {
			// these data we can't set under resources/js/app.js as we need runtime data 
			// new_msgs_data['whatsapp_icon_src'] = this.baseroute + '/images/whatsapp-icon.svg';
        	/* These data previous set inside app.js */
			//Sia250224-change var to window. to make it global to blade
			window.new_msgs_data = { 
				newMsgs_list		: [],     // define empty variable
				newMsgs_count		: 0,
				currentDateTime 	: null,
				moment          	: moment,
			};
			new_msgs_data['whatsapp_icon_src'] = 'https://cdnsms.360.my/images/whatsapp-icon.svg';
			new_msgs_data['inbox_url'] = this.baseroute + '/inbox';
			return "";		// load data from resources/js/app.js, this way, we can share the data across the html
		},
		created() {     // Run this after vue object created
			this.fetchNewMsgsList();
		},
		props: [		// Data pass in from layout.blade.php
			'user_id',	
			'company_id',
        	'baseroute',
        	'testProps',
        	'newMsgs_count_prop',
		],
		methods: {
			fetchNewMsgsList() {     // Define the fetchCurrencies() function 
				console.log("fetchNewMsgsList(), this.baseroute = " + this.baseroute + '/getNewMsgsList');
				this.currentDateTime = moment();
				axios.get(this.baseroute + '/getNewMsgsList')
				  .then(response => {
				      console.log(response);
				      this.newMsgs_count = response.data.newMsgCount;
				      this.newMsgs_list = response.data.new_msgs_list;

				      console.log("newMsgs_list = ");
				      console.log(this.newMsgs_list);
				  })
				  .catch(function (error) {
				      // Wu oh! Something went wrong
				      console.log("Failed fecthing new msg");
				      console.log(error.message);
				  });
			},
		},
		mounted() {     // Run this after vue object mounted on html screen 
		  	console.log('NewMsgsList.vue Component mounted.')
		},
		computed: {

		}
    }
</script>

<style>
.greeting {
  color: red;
  font-weight: bold;
}
</style>